
import React, { useEffect, useState } from "react";
import { MasterConfigs } from "../../../../../../interfaces/entity";
import CommonView, { CommonViewProps } from "../../../../../../components/CommonView/CommonView";
import { Button, Card, Col, Divider, Empty, Flex, Form, List, Modal, notification, Row, Space, Typography } from "antd";
import { CheckCircleOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons'
import FormSetup from "../../../../../../components/Forms/FormSetup";
import MasterComponent from "../../../../../../components/Forms";
import { useDispatch } from "react-redux";
import { postData, putData } from "../../../../../../actions/developer";
import MentionsComponent from "../../../../../../components/Mentions/Mentions";
import InfiniteScrollList from "../../../../../../components/Forms/ListView/InfiniteScrollList";
import { deleteRow } from "../../../../../../actions/apiCall";
const { Text, Title } = Typography;
const { confirm } = Modal;
const { useForm } = Form;

interface ComponentItem {
    recurringComponent?: {
        name?: string;
        description?: string;
        componentType?: string;
    },
    formula?: string;
    locked: boolean;
    _id: string;
}

const RangeBased = () => {
    const [selectedItem, setSelectedItem] = useState<ComponentItem | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedListItem, setSelectedListItem] = useState(null);
    const [load, setLoad] = useState(false);
    const [form] = useForm();
    const dispatch = useDispatch();

    const config: MasterConfigs = {
        api: () => '/salary-structure-type',
        title: 'Salary Structure Type',
        modalTitle: () => config.title,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add' }]
    }

    const commonViewProps: CommonViewProps = {
        listProps: {
            height: 300,
        },
        config: config,
        componentConfig: {
            buttonName: 'Salary Structure Type',
            title: 'Salary Structure Type',
            subTitle: 'Manage Salary Structure Type',
            cardTitle: 'Salary Structures',
            emptyDescription: 'Please select a Salary Structure Type to view',
            renderListItem: (item) => {
                return <>
                    <Title level={5} style={{ lineHeight: 1.2, marginBottom: 0 }}>{item.name}</Title>
                    <Text type="secondary">{item?.code}</Text>
                </>
            },
            renderComponent: (item) => renderComponent(item),
            selectedItemId: (id) => setSelectedListItem(id)
        }
    }

    const checkedValues = (items) => {
        const taxValues = [{
            label: 'This component is tax exempted (Non taxable)',
            name: 'taxExempted',
        },
        {
            label: 'This element is a part of the Bouquet of Benefits (BOB) of the Flexible Benefit Plan (FBP).',
            name: 'bob',
        },
        {
            label: 'Add this component to the computation of arrears.',
            name: 'computationArrears',
        },
        {
            label: 'Allow customization and employee level overrides for this component.',
            name: 'customization',
        },
        {
            label: 'Include this item in your earnings and deductions.',
            name: 'earnings',
        },
        {
            label: 'Pay this component separately with its own statement.',
            name: 'separateStatement',
        },
        {
            label: 'Hide component in payroll (and exclude from gross earnings calculation in Payslip)',
            name: 'hideComponent',
        },
        {
            label: 'Pay this amount in addition to the employee\'s annual salary.',
            name: 'annualSalary',
        },
        {
            label: 'The component value is unaffected by loss of pay (LOP) due to attendance or unpaid leave.',
            name: 'lop',
        },
        {
            label: 'Adjust the difference amount (Paid value - Actual value due to LOP) against special allowance.',
            name: 'specialAllowance',
        }]
        return <>
            <Row gutter={[16, 16]}>
                {Object.keys(items).map((ele) => {
                    const item = taxValues.find(item => items[ele] && item.name === ele)
                    if (!item) {
                        return null
                    }
                    return <Col span={24} key={ele}>
                        <Space direction="horizontal">
                            <CheckCircleOutlined style={{ color: 'green' }} /> {item?.label}
                        </Space>
                    </Col>
                })}
            </Row>
        </>
    }

    const onDelete = (id) => {
        confirm({
            title: 'Do you want to delete this component?',
            content: 'When clicked the OK button, this component will be deleted and cannot be recovered',
            async onOk() {
                const response = await dispatch(deleteRow(`/salary-components-settings/${id}`));
                if (response.code === 200) {
                    notification.success({ message: 'Record deleted successfully' })
                    setLoad(true)
                    setSelectedItem(null)
                } else {
                    notification.error({ message: 'Error', description: 'Something Went wrong' })
                }
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const onSaveFarmula = async (values) => {
        console.log(values)
        const resData = await dispatch(putData(`/salary-components-settings/${selectedItem?._id}`, values))
        if (resData) {
            setLoad(true)
            setSelectedItem(null)
        }
    }

    useEffect(() => {
        if (selectedItem) {
            form.setFieldsValue({ formula: selectedItem?.formula })
        }
    }, [selectedItem])

    const renderComponent = (item) => {
        return <>
            <Button type="link" style={{ marginBottom: 20 }} onClick={() => setIsOpen(true)}>Add Component</Button>
            <div style={{ display: "flex", gap: "20px" }}>
                <div style={{ flex: 1 }}>
                    <Card title={'Components'} bordered>
                        <InfiniteScrollList
                            apiUrl={`/salary-components-settings?salaryStructure=${selectedListItem}`}
                            reload={load}
                            height={300}
                            onLoaded={() => setLoad(false)}
                            renderItem={(item) =>
                                <List.Item
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setSelectedItem(item)
                                    }}
                                >
                                    <Space direction="vertical">
                                        <Text>{item?.recurringComponent?.name}</Text>
                                        <Text type="secondary">{item?.formula}</Text>
                                    </Space>
                                    <Text type="secondary" style={{ textTransform: 'capitalize' }}>{item?.recurringComponent?.componentType}</Text>
                                </List.Item>
                            }
                        />
                    </Card>
                </div>
                <div style={{ flex: 1 }}>
                    {selectedItem ? (
                        <Card title={<>
                            <Flex justify="space-between" align="center">
                                <Title level={5}>{selectedItem?.recurringComponent?.name}</Title>
                                {selectedItem && <>
                                    <Space direction="horizontal" size={[0, 0]}>
                                        <Button type="link" onClick={() => onDelete(selectedItem?._id)} danger icon={<DeleteOutlined />} />
                                        <Button type="text" onClick={() => form.submit()} icon={<SaveOutlined />} />
                                    </Space>
                                </>}
                            </Flex>
                        </>} bordered>
                            {selectedItem?.recurringComponent?.description && <>
                                <Text type="secondary">{`${selectedItem?.recurringComponent?.description}`}</Text>
                                <Divider />
                            </>}
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onSaveFarmula}
                            >
                                <MentionsComponent config={{
                                    api: `/salary-component-fields/${item?._id}`,
                                    formField: {
                                        name: 'formula',
                                        rules: [{ required: true, message: 'Please enter formula' }],
                                    },
                                    render: (item) => item.map((ele) => ({ value: ele, label: ele })),
                                    mentionsProps: {
                                        prefix: '['
                                    }
                                }} />
                            </Form>
                            <Divider />
                            <Title level={5}>Characteristics</Title>
                            {checkedValues(selectedItem?.recurringComponent)}
                        </Card>
                    ) : (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="Please select a component to view"
                        />
                    )}
                </div>
            </div>
        </>
    }

    const RecuringComponents: MasterConfigs = {
        api: () => '/recurring-components',
        modalTitle: () => "Recuring Components",
        tableProps: {
            scroll: { x: 500 },
            rowSelection: {
                type: 'checkbox',
                onChange: (selectedRowKeys: any, selectedRows: any) => {
                    console.log(selectedRowKeys, selectedRows)
                    setSelectedRow(selectedRowKeys)
                }
            },
        },
        getColumns: () => [
            {
                title: 'Component Name',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                fixed: 'left',
            },
            {
                title: 'Component Type',
                dataIndex: 'componentType',
                key: 'componentType',
                width: 200,
                fixed: 'left',
            },
            {
                title: 'Maximum Limit (Year)',
                dataIndex: 'maxLimit',
                key: 'maxLimit',
                width: 200,
            },
            {
                title: 'Tax Exempted',
                dataIndex: 'taxExempted',
                key: 'taxExempted',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'BOB',
                dataIndex: 'bob',
                key: 'bob',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Arrears',
                dataIndex: 'computationArrears',
                key: 'computationArrears',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Customization',
                dataIndex: 'customization',
                key: 'customization',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Earnings',
                dataIndex: 'earnings',
                key: 'earnings',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Separate Statement',
                dataIndex: 'separateStatement',
                key: 'separateStatement',
                width: 200,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Hide Component',
                dataIndex: 'hideComponent',
                key: 'hideComponent',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Annual Salary',
                dataIndex: 'annualSalary',
                key: 'annualSalary',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'LOP',
                dataIndex: 'lop',
                key: 'lop',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No'
            },
            {
                title: 'Special Allowance',
                dataIndex: 'specialAllowance',
                key: 'specialAllowance',
                width: 200,
                render: (text: any) => text ? 'Yes' : 'No'
            }
        ],
    }

    useEffect(() => {
        if (selectedListItem) {
            setLoad(true)
            setSelectedItem(null)
        }
    }, [selectedListItem])

    const onAddComponent = async () => {
        const payload = selectedRow.map((item) => ({ recurringComponent: item, salaryStructure: selectedListItem, order: 0 }))
        const response = await dispatch(postData('/salary-components-settings/bulk', payload));
        return response
    }

    const componentConfig: MasterConfigs = {
        title: 'Salary Structure Type',
        modalProps: { width: '80%' },
        modalTitle: () => componentConfig.title,
        onSubmit: async (id, data) => {
            return await onAddComponent()
        },
        getFormColumns: () => [
            {
                type: 'custom',
                formItem: () => <MasterComponent config={RecuringComponents} />,
                span: 24
            },
        ],
    }

    return <>
        <FormSetup config={componentConfig} onClose={() => setIsOpen(false)} open={isOpen} isModal={true} />
        <CommonView {...commonViewProps} />
    </>
}

export default RangeBased;